import { useCallback } from 'react';

import { Box } from '@twilio-paste/core/box';
import { MultiselectCombobox } from '@twilio-paste/core/combobox';
import { useUIDSeed } from '@twilio-paste/core/dist/uid-library';
import { useFormikContext } from 'formik';

import { ScopeModel } from '../../../modules/Apps';
import { InfoLabel } from '../../common/InfoLabel';

import { TargetsFormValues } from './types';

interface SelectScopesDropDownProps {
  scopes: ScopeModel[];
  readOnly?: boolean;
}

export function SelectScopesDropDown({ scopes, readOnly }: SelectScopesDropDownProps) {
  const seed = useUIDSeed();
  const { setFieldValue, values } = useFormikContext<TargetsFormValues>();
  const onSelectedItemsChange = useCallback(
    (items: any) => {
      setFieldValue('scopes', items);
    },
    [setFieldValue],
  );

  return (
    <MultiselectCombobox
      items={scopes}
      labelText={
        <InfoLabel
          htmlFor={seed('scopes')}
          infoText="Select the scopes associated with this application target."
        >
          Target Scopes
        </InfoLabel>
      }
      optionTemplate={(item: ScopeModel) => <Box>{item.name}</Box>}
      itemToString={(item: ScopeModel) => (item ? item.name : '')}
      selectedItemsLabelText="Selected Scopes"
      onSelectedItemsChange={onSelectedItemsChange}
      initialSelectedItems={values.scopes}
      disabled={readOnly}
    ></MultiselectCombobox>
  );
}
